import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Logo, Panel, Btn } from "@/components/kit";
import api from "@/lib/api";

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const reference = params.get("reference") || params.get("trxref");
  const [state, setState] = useState("verifying"); // verifying | success | failed

  useEffect(() => {
    if (!reference) { setState("failed"); return; }
    api.get(`/subscription/verify/${reference}`)
      .then((r) => setState(r.data.status === "success" ? "success" : "failed"))
      .catch(() => setState("failed"));
  }, [reference]);

  return (
    <div className="bd-page flex flex-col items-center justify-center px-6 min-h-screen">
      <Link to="/" className="mb-8"><Logo /></Link>
      <Panel className="w-full max-w-md p-8 text-center" data-testid="payment-callback">
        {state === "verifying" && (
          <>
            <Loader2 size={40} className="mx-auto text-[#FF6B7D] animate-spin" />
            <h1 className="font-head text-2xl font-bold text-white mt-4">Verifying payment…</h1>
            <p className="text-sm text-purple-300/70 mt-2">Please wait while we confirm your transaction.</p>
          </>
        )}
        {state === "success" && (
          <>
            <CheckCircle2 size={48} className="mx-auto text-emerald-400" />
            <h1 className="font-head text-2xl font-bold text-white mt-4" data-testid="payment-success">Payment successful</h1>
            <p className="text-sm text-purple-300/70 mt-2">Your subscription is now active.</p>
            <Btn className="w-full mt-6" data-testid="payment-continue" onClick={() => navigate("/admin")}>Go to dashboard</Btn>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle size={48} className="mx-auto text-rose-400" />
            <h1 className="font-head text-2xl font-bold text-white mt-4" data-testid="payment-failed">Payment not completed</h1>
            <p className="text-sm text-purple-300/70 mt-2">We couldn't confirm your payment. You can try again from the Billing page.</p>
            <Btn variant="secondary" className="w-full mt-6" onClick={() => navigate("/admin")}>Back to dashboard</Btn>
          </>
        )}
      </Panel>
    </div>
  );
}
